export const defaultLang = "en";
export const pathLangdata = "/htmldata/lang/";
export const langsList = ["en","fr"];
export const pathHTMLdata = "../../../htmldata/";
export const colors = ["#66CC00","#4E57EB","#7D77F0","#D65447","#54E0F2","#FF737C","#D4C24F","#E9CD80","#1FAF39","#BC61B7","#CBCBCA","#FDFFFA","#010300"]
export const bandeDelay = 150;
export const bandeTranslationCount = 10;